























































































































































































































































































































































































import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  BUSSINNESS_CATEGORY,
  BUSINESS_WITH_NULL
} from '../../../service/constant'
import {
  batchDirectPass,
  fetchJzdxTopics,
  getCurrentUserInfo,
  getTodoTaskList,
  queryGroupUser,
  startWorkflow,
  getDistributeResource
} from '../../../service/manage'
import { Cache, SongGuo } from '../../../service/common'
import { FORM_ITEM_LAYOUT } from '../config/'
import { CATEGORIES } from '@/config/'
import { sourceColumns } from '../config/columns'
import { column, option } from '../interface/'

@Component
export default class TaskQuerySource extends Vue {
  private categories = CATEGORIES

  public get dict() {
    return this.$store.state[BUSSINESS_SUBJECTS]
  }
  public get category() {
    return this.$store.state[BUSSINNESS_CATEGORY]
  }
  // 未分配资源
  private get business() {
    return this.$store.state[BUSSINESS]
  }
  private get subjects() {
    if (!this.sourceForm.business_type) return []
    return this.dict[this.sourceForm.business_type] || []
  }
  private get taskBusiness() {
    return [...this.$store.state[BUSINESS_WITH_NULL]]
  }
  private get taskSubjects() {
    if (!this.taskForm.business_type || this.taskForm.business_type == '-1') return []
    return this.dict[this.taskForm.business_type] || []
  }
  // 需要根据资源和学科获取分类
  private get sourceFormCategoryOptions() {
    var sourceData: any = []
    if (!this.sourceForm.business_type) return []
    for (var item of this.category[this.sourceForm.business_type]) {
      for (var key in item) {
        if (key == this.sourceForm.subject_id) {
          const ishas: boolean = item[key].some((item) => item.value == '')
          if (!ishas) {
            item[key].unshift({ value: '', label: '不限' })
          }
          sourceData = item[key] || []
        }
      }
    }
    return sourceData
  }
  private get taskFormCategoryOptions() {
    var sourceData: any = []

    if (!this.taskForm.business_type) return []

    for (var item of this.category[this.taskForm.business_type]) {
      for (var key in item) {
        if (key == this.taskForm.subject_id) {
          const ishas: boolean = item[key].some((item) => item.value == '')
          if (!ishas) {
            item[key].unshift({ value: '', label: '不限' })
          }

          sourceData = item[key] || []
        }
      }
    }
    return sourceData
  }
  private get packFormCategoryOptions() {
    var sourceData: any = []
    if (!this.packForm.business_type) return []
    for (var item of this.category[this.packForm.business_type]) {
      for (var key in item) {
        if (key == this.packForm.subject_id) {
          const ishas: boolean = item[key].some((item) => item.value == '')
          if (!ishas) {
            item[key].unshift({ value: '', label: '不限' })
          }
          sourceData = item[key] || []
        }
      }
    }
    return sourceData
  }

  // 显示松果AI分类
  private get taskFormShowCategory() {
    return [6003, 6004, 7001].includes(Number(this.taskForm.business_type))
  }

  private get packFormShowCategory() {
    return [6003, 7001].includes(Number(this.packForm.business_type))
  }

  private get sourceFormShowCategory() {
    return [6003, 6004, 7001].includes(Number(this.sourceForm.business_type))
  }

  // 显示自媒体分类
  private get showWeMediaCategory() {
    return [8001].includes(Number(this.taskForm.business_type))
  }

  // 批量通过 Modal
  private get packBusiness() {
    let arr = JSON.parse(JSON.stringify(this.$store.state[BUSSINESS]))
    let idx = arr.findIndex((item) => item.value === 7001)
    arr.splice(idx, 1)
    return arr
  }
  private get packSubjects() {
    if (!this.packForm.business_type) return []
    return this.dict[this.packForm.business_type] || []
  }
  private get packStatusOptions(): { label: string; value: string }[] {
    if (this.packFormShowTopic || this.packForm.business_type == '6003') {
      return [{ value: 'unassign', label: '待审核' }]
    } else {
      return [
        { value: '', label: '不限' },
        { value: 'first_unassign', label: '一审未分配' },
        { value: 'second_unassign', label: '二审未分配' }
      ]
    }
  }
  // 批量通过 Modal end

  // 未分配资源查询条件
  private get sourceFormStatusOptions(): { label: string; value: string }[] {
    if (this.sourceForm.subject_id == 801 && this.sourceForm.business_type == 6001) {
      return [{ label: '未分配', value: 'unassign' }]
    } else if (this.sourceForm.subject_id == 802 && this.sourceForm.business_type == 6002) {
      return [{ label: '未分配', value: 'unassign' }]
    } else if (this.sourceForm.business_type == 6003) {
      return [{ label: '未分配', value: 'unassign' }]
    } else {
      return [
        { value: '', label: '不限' },
        { label: '一审未分配', value: 'first_unassign' },
        { label: '二审未分配', value: 'second_unassign' }
      ]
    }
  }

  // 分配任务 Modal
  private get taskFormStatusOptions(): { label: string; value: string }[] {
    if (
      (this.taskForm.subject_id == '801' && this.taskForm.business_type == '6001') ||
      (this.taskForm.subject_id == '802' && this.taskForm.business_type == '6002') ||
      this.taskForm.business_type == '6003' ||
      this.taskForm.business_type == '6004'
    ) {
      return [{ label: '未分配', value: 'unassign' }]
    } else {
      return [
        { label: '一审未分配', value: 'first_unassign' },
        { label: '二审未分配', value: 'second_unassign' }
      ]
    }
  }
  // 分配任务 Modal end

  // 家长大学 批量通过
  private get packFormShowTopic() {
    return this.packForm.business_type == '6001' && this.packForm.subject_id == '801'
  }
  // 家长大学 任务分配
  private get taskFormShowTopic() {
    return this.taskForm.business_type == '6001' && this.taskForm.subject_id == '801'
  }

  public emailRegExp = new RegExp(
    '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
  )
  public formItemLayout = FORM_ITEM_LAYOUT
  public sourcePagination = {
    total: 0,
    current: 1,
    showTotal: (total) => `共 ${total} 条`
  }
  public dataSource: any[] = []
  public sourceColumns: column[] = sourceColumns
  // 任务分配 Modal
  public defaultTaskForm = {
    user_id: '',
    instance_name: '',
    status: 'first_unassign',
    handler_user_ids: [],
    time: ['', ''],
    tag: '',
    resource_amount: '',
    email: '',
    valid_time: 0,
    business_type: this.taskBusiness[0].value,
    subject_id: '',
    topic_id: '', // 家长大学特有
    category: ''
  }
  public taskModal = {
    visible: false
  }
  public taskForm = {
    business_type: '',
    subject_id: '',
    user_id: '',
    instance_name: '',
    status: 'first_unassign',
    handler_user_ids: [],
    time: ['', ''],
    tag: '',
    resource_amount: '',
    email: '',
    valid_time: 0,
    topic_id: '', // 家长大学特有
    category: ''
  }
  public reviewer: any[] = []
  public defaultTaskFormTime = []
  public isValid = true

  public defaultPackForm = {
    business_type: '',
    subject_id: '',
    status: '',
    tag: '',
    time: ['', ''],
    email: '',
    topic_id: '', // 家长大学特有字段
    category: ''
  }
  public defaultPackFormTime = []
  public packModal = {
    visible: false
  }
  public packForm = {
    business_type: '',
    subject_id: '',
    tag: '',
    time: ['', ''],
    email: '',
    status: '',
    topic_id: '', // 家长大学特有字段
    category: ''
  }
  public flag = true

  private packFormJzdxTopicOptions = [] // 批量通过 家长大学topic optoins
  private taskFormJzdxTopicOptions = [] // 任务分配 家长大学topic optoins
  private distributeResource = '' // 获取待分配资源总数

  // end
  private sourceForm: any = {
    resource_id: '',
    business_type: 0,
    subject_id: 0,
    time: ['', ''],
    status: '',
    tag: '',
    category: ''
  }

  @Watch('taskFormStatusOptions')
  public onTaskFormStatusOptionsChange() {
    this.taskForm.status = this.taskFormStatusOptions[0].value
    this.onOptionsChange()
  }

  public handleJzdxTopicSearch(value: string) {
    fetchJzdxTopics(value).then((items) => {
      this.packFormJzdxTopicOptions = items || []
    })
  }

  public handleJzdxTopicSearchAssignTask(value: string) {
    fetchJzdxTopics(value).then((items) => {
      this.taskFormJzdxTopicOptions = items || []
    })
  }

  public async mounted() {
    // @ts-ignore
    window.batch = this
    const query = this.$route.query
    this.sourceForm.business_type = query.business_id
      ? Number(query.business_id)
      : this.business[0].value
    this.taskForm.business_type = this.taskBusiness[0].value
    this.packForm.business_type = this.packBusiness[0].value
    if (query.subject_id) {
      this.sourceForm.subject_id = Number(query.subject_id)
    }
    if (query.category) {
      this.sourceForm.category = query.category
    }
    await this.renderTodoList(1)
  }
  @Watch('sourceForm.business_type')
  public onBussinessChange(val) {
    if (!this.subjects || this.subjects.length == 0) return
    if (!this.subjects.map((item) => item.value).includes(this.sourceForm.subject_id)) {
      setTimeout(() => {
        this.sourceForm.subject_id = this.subjects[0].value
        const query = this.$route.query
        if (query.subject_id) {
          this.sourceForm.subject_id = Number(query.subject_id)
        }
      })
    }
  }
  public handleSourceTableChange(pagination) {
    this.renderTodoList(pagination.current)
  }
  public async renderTodoList(page_num) {
    const options = {
      subject_id: Number(this.sourceForm.subject_id),
      business_type: Number(this.sourceForm.business_type),
      start_at: this.sourceForm.time[0],
      end_at: this.sourceForm.time[1],
      status: this.sourceForm.status,
      resource_id: this.sourceForm.resource_id,
      tag: this.sourceForm.tag,
      category: this.sourceForm.category,
      page_num,
      page_size: 10
    }
    const { list, total } = await getTodoTaskList(options)
    this.dataSource = list
    this.sourcePagination.total = total
    this.sourcePagination.current = page_num
  }
  public onSourceTimeChange(date, dateString) {
    this.sourceForm.time = dateString
  }
  public handleSourceFormSubmit(e) {
    this.renderTodoList(1)
  }
  @Watch('taskForm.business_type')
  public onTaskBussinessChange(val) {
    if (!this.taskSubjects || this.taskSubjects.length == 0) return
    if (!this.taskSubjects.map((item) => item.value).includes(this.taskForm.subject_id)) {
      setTimeout(() => {
        this.taskForm.subject_id = this.taskSubjects[0].value
      })
    }
  }
  public async showTaskModal(e) {
    this.taskModal.visible = true

    // 更新上次的email
    this.taskForm.email = Cache.read('CACHE_LS_ADMIN_EMAIL') || ''
    await this.renderReviewerList()
    await this.getInstanceDistributeResource()
  }
  public onTaskModalRangeChange(date, dateString) {
    this.taskForm.time = dateString
    this.onOptionsChange()
  }
  public async handleTaskModalOk(e) {
    if (!this.isValid) {
      return
    }

    const email = this.taskForm.email
    Cache.write('CACHE_LS_ADMIN_EMAIL', email)
    const userIds = this.taskForm.handler_user_ids.filter((n) => {
      return n !== 'all'
    })

    const options = {
      instance_name: this.taskForm.instance_name,
      user_id: this.taskForm.user_id,
      business_type: Number(this.taskForm.business_type),
      subject_id: Number(this.taskForm.subject_id),
      put_start_time: this.taskForm.time[0],
      put_end_time: this.taskForm.time[1],
      handler_user_ids: userIds,
      tag: this.taskForm.tag,
      resource_amount: Number(this.taskForm.resource_amount),
      email,
      status: this.taskForm.status,
      valid_time: Number(this.taskForm.valid_time),
      topic_id: this.taskForm.topic_id, // 家长大学topic字段
      category: this.taskForm.category
    }
    const res = await getCurrentUserInfo()
    options.user_id = res.id
    if (!options.instance_name) {
      this.$message.info('任务名称不能为空！')
      return
    }
    if (options.handler_user_ids.length <= 0) {
      this.$message.info('审核人不能为空！')
      return
    }
    if (options.resource_amount <= 0) {
      this.$message.info('每人资源数量必须大于0')
      return
    }
    if (options.valid_time <= 0 || options.valid_time > 500) {
      this.$message.info('审核时效要大于0小于等于500')
      return
    }
    if (options.email === '') {
      this.$message.info('管理员邮箱不能为空！')
      return
    } else if (!this.emailRegExp.test(options.email)) {
      this.$message.info('请填写正确的管理员邮箱！')
      return
    }
    this.isValid = false
    const startResponse: any = await startWorkflow(options)
    if (startResponse.success) {
      this.$message.success('任务正在分配，请查收邮件结果通知。')
    }
    await this.renderTodoList(1)
    this.resetTaskModalForm()
    setTimeout(() => {
      this.taskModal.visible = false
      this.isValid = true
    })
  }
  public handleTaskModalCancel(e) {
    this.resetTaskModalForm()
  }
  public resetTaskModalForm() {
    this.taskForm = { ...this.defaultTaskForm }
    this.taskForm.business_type = this.taskBusiness[0].value
    this.taskForm.subject_id = this.taskSubjects.length > 0 ? this.taskSubjects[0].value : ''
    this.defaultTaskFormTime = []
  }
  public async handleStatusChange() {
    this.renderReviewerList()
    this.onOptionsChange()
  }
  public async renderReviewerList() {
    const options = {
      status: this.taskForm.status
    }
    const res = await queryGroupUser(options)
    let result = res.map((item: { id: string; name: string }) => {
      return { value: item.id, title: item.name }
    })
    this.reviewer = [{ value: 'all', title: '全部' }, ...result]
  }
  @Watch('packForm.business_type')
  public onPackBussinessChange(val) {
    if (!this.packSubjects || this.packSubjects.length == 0) return
    if (!this.packSubjects.map((item) => item.value).includes(this.packForm.subject_id)) {
      setTimeout(() => {
        console.log(this.packSubjects)
        this.packForm.subject_id = this.packSubjects[0].value
      })
    }
  }
  public resetPackModalForm() {
    this.packForm = { ...this.defaultPackForm }
    this.packForm.business_type = this.packBusiness[0].value
    this.packForm.subject_id = this.packSubjects[0].value
    this.defaultPackFormTime = []
  }
  public handlePackModalCancel(e) {
    this.resetPackModalForm()
  }
  public async handlePackModalOk(e) {
    const email = this.packForm.email
    Cache.write('CACHE_LS_ADMIN_EMAIL', email)

    const options = {
      business_type: Number(this.packForm.business_type),
      subject_id: Number(this.packForm.subject_id),
      put_start_time: this.packForm.time[0],
      put_end_time: this.packForm.time[1],
      tag: this.packForm.tag,
      email,
      status: this.packForm.status,
      topic_id: this.packForm.topic_id,
      category: this.packForm.category
    }
    if (this.packFormShowTopic && this.packForm.topic_id == '') {
      this.$message.info('话题不能为空！')
      return
    }
    if (options.email === '') {
      this.$message.info('邮箱不能为空！')
      return
    } else if (!this.emailRegExp.test(options.email)) {
      this.$message.info('请填写正确的邮箱！')
      return
    }
    const res = await batchDirectPass(options)
    if (res.success) {
      this.$message.success('任务正在批量通过，请查收邮件结果通知。')
    }
    this.resetPackModalForm()
    setTimeout(() => {
      this.packModal.visible = false
    })
  }
  public showPackModal(e) {
    this.packModal.visible = true
    // 读取上次email
    this.packForm.email = Cache.read('CACHE_LS_ADMIN_EMAIL') || ''
  }
  public onPackModalRangeChange(date, dateString) {
    this.packForm.time = dateString
  }
  // 获取待分配资源总数
  public async getInstanceDistributeResource() {
    let options = {
      business_type: Number(this.taskForm.business_type),
      subject_id: Number(this.taskForm.subject_id),
      put_start_time: this.taskForm.time[0],
      put_end_time: this.taskForm.time[1],
      tag: this.taskForm.tag,
      status: this.taskForm.status,
      topic_id: this.taskForm.topic_id,
      category: this.taskForm.category || undefined
    }
    let str = ''
    if (!this.taskModal.visible) {
      return
    }
    if (this.taskForm.business_type != '-1') {
      str = await getDistributeResource(options)
    }
    this.distributeResource = str ? `共有${str}条待审资源` : '共有0条待审资源'
  }
  public onOptionsChange() {
    this.getInstanceDistributeResource()
  }

  @Watch('sourceFormStatusOptions')
  private onSourceFormStatusOptionsChange() {
    // options 变化时更新默认值
    this.sourceForm.status = this.sourceFormStatusOptions[0].value
  }
  @Watch('packStatusOptions')
  private onShowTopic(val: boolean) {
    this.packForm.status = this.packStatusOptions[0].value
  }
  @Watch('taskForm.handler_user_ids')
  private onTaskFormUserIdChange(val, old) {
    let arr: any = []
    let option: string = ''
    // 判断选项，选中/取消
    if (old.includes('all') && !val.includes('all')) {
      if (this.flag) {
        this.taskForm.handler_user_ids = []
        this.flag = true
      }
    } else if (!old.includes('all') && val.includes('all')) {
      arr = this.reviewer.map((item) => item.value)
      this.taskForm.handler_user_ids = arr
      this.flag = true
    } else if (old.includes('all') && val.includes('all')) {
      if (old.length > val.length) {
        this.taskForm.handler_user_ids = this.taskForm.handler_user_ids.filter((n) => n !== 'all')
        this.flag = false
      } else {
        this.flag = true
      }
    }
  }
}
